import { defineStore } from 'pinia';
import api from '@/api';

export const useStationTypeStore = defineStore('stationType', {
  state: () => ({
    stationTypes: [],
    lookups: [],
    myLookups: [],
    loading: false,
    error: null
  }),

  getters: {
    getStationTypes: (state) => state.stationTypes,
    getLookups: (state) => state.lookups,
    getMyLookups: (state) => state.myLookups,
    isLoading: (state) => state.loading,
    getError: (state) => state.error
  },

  actions: {
    async fetchStationTypes(params = {}) {
      this.loading = true;
      this.error = null;
      try {
        const resp = await api.stationType.getStationTypes(params);
        this.stationTypes = resp.data || [];
      } catch (e) {
        this.error = e;
        this.stationTypes = [];
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async fetchLookups() {
      try {
        const resp = await api.stationType.getLookups();
        this.lookups = resp.data || [];
      } catch (e) {
        this.lookups = [];
        throw e;
      }
    },

    async fetchMyLookups() {
      try {
        const resp = await api.stationType.getMyLookups();
        this.myLookups = resp.data || [];
      } catch (e) {
        this.myLookups = [];
        throw e;
      }
    },

    async createStationType(payload) {
      this.loading = true;
      this.error = null;
      try {
        const resp = await api.stationType.createStationType(payload);
        this.stationTypes.push(resp.data);
        return resp.data;
      } catch (e) {
        this.error = e;
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async updateStationType(id, payload) {
      this.loading = true;
      this.error = null;
      try {
        const resp = await api.stationType.updateStationType(id, payload);
        const index = this.stationTypes.findIndex(st => st.stationTypeId === id);
        if (index >= 0) {
          this.stationTypes[index] = resp.data;
        }
        return resp.data;
      } catch (e) {
        this.error = e;
        throw e;
      } finally {
        this.loading = false;
      }
    },

    async deleteStationType(id) {
      this.loading = true;
      this.error = null;
      try {
        await api.stationType.deleteStationType(id);
        this.stationTypes = this.stationTypes.filter(st => st.stationTypeId !== id);
      } catch (e) {
        this.error = e;
        throw e;
      } finally {
        this.loading = false;
      }
    },

    clearAll() {
      this.stationTypes = [];
      this.lookups = [];
      this.myLookups = [];
      this.error = null;
    }
  }
});
